import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import {
  Form, FormGroup, Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupButton,
  Button,
  ListGroup,
  ListGroupItem
} from "reactstrap";

import $ from "jquery";
import { IMAGE } from "common-import/constants";
import { Request, VarHelper } from "common-import/helpers";
import { Carousel } from "common-import/custom";

import { DateRangePicker, SingleDatePicker, DayPickerRangeController } from 'react-dates';

export default class MakeForm extends Component {

  static propTypes = {
    onSubmit: PropTypes.func,
    parent: PropTypes.object,
    stateLabel: PropTypes.string,
    template: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      label: PropTypes.string,
      type: PropTypes.oneOf(["string", "number", "string select", "range number select", "array select", "array upload", "string upload", "date duration"]),
      selectData: PropTypes.array,
      urlType: PropTypes.oneOf(["file", "image", "image cover"]),
      dateName: PropTypes.array,
      isRequired: PropTypes.bool,
      customOnChange: PropTypes.func
    })) 
  };

  state = (() => {
    let obj = {};
    this.props.template.forEach(val => obj[val.name] = "");
    return obj;
  })();

  onChange = (e, item) => {
    const { name, label, type, isRequired } = item;
    const value = $(e.target).val();
    this.setState({ [name]: value });
    if(!!item.customOnChange) item.customOnChange(value);
  };

  renderString = (item, index) => {
    const { name, label, type, isRequired } = item;
    return (
      <FormGroup key={"propString" + index}>
        <Label htmlFor={"nf-" + name}>{label}: {isRequired ? "*" : ""}</Label>
        <Input  type="text"  id={"nf-" + name} name={"nf-" + name}
          value={this.state[name]} 
          // onChange={e => this.setState({ [name]: $(e.target).val() })}
          onChange={e => this.onChange(e, item)}
        />
      </FormGroup>
    )
  };

  renderNumber = (item, index) => {
    const { name, label, type, isRequired } = item;
    return (
      <FormGroup key={"propNumber" + index}>
        <Label htmlFor={"nf-" + name}>{label}: {isRequired ? "*" : ""}</Label>
        <Input  type="text"  id={"nf-" + name} name={"nf-" + name}
          value={this.state[name]} 
          // onChange={e => this.setState({ [name]: $(e.target).val() })}
          onChange={e => this.onChange(e, item)}
        />
      </FormGroup>
    )
  };

  renderArraySelect = (item, index) => {
    const { name, label, type, selectData, isRequired } = item;
    return (
      <FormGroup key={"propArraySelectr" + index}>
        <Label htmlFor={"nf-" + name}>{label}: {isRequired ? "*" : ""}</Label>
        <Input type="select" defaultValue={[""]} multiple
          value={this.state[name]} 
          onChange={e => this.onChange(e, item)}
          // onChange={e => this.setState({ [name]: $(e.target).val() })}
          >
            <option value={""}></option>
            {selectData.slice().map((item, i) => (
              <option key={"option"+i} value={item.value}>{item.title}</option>
            ))}
        </Input>
      </FormGroup>
    )
  };

  renderStringSelect = (item, index) => {
    const { name, label, type, selectData, isRequired } = item;
    return (
      <FormGroup key={"propStringSelect" + index}>
        <Label htmlFor={"nf-" + name}>{label}: {isRequired ? "*" : ""}</Label>
        <Input type="select" defaultValue={""} value={this.state[name]} 
          // onChange={e => this.setState({ [name]: $(e.target).val() })}
          onChange={e => this.onChange(e, item)}
          >
            <option value={""}></option>
            {selectData.slice().map((item, i) => (
              <option key={"option"+i} value={item.value}>{item.title}</option>
            ))}
        </Input>
        { this.state[name].includes("__") && 
        <Input type="text" onChange={e => this.setState({ [name+"__"]: $(e.target).val() })}
          defaultValue={""} value={this.state[name+"__"]} placeholder={"Điền tiếp vào để hoàn thành"} /> }
      </FormGroup>
    )
  };

  // renderRangeNumberSelect = (item, index) => {
  //   const { name, label, type, selectData, isRequired, rangeName } = item;
  //   let [from, to] = rangeName;
  //   return (
  //     <FormGroup key={"propRangeNumberSelect" + index}>
  //       <Label htmlFor={"nf-" + name}>{label}: {isRequired ? "*" : ""}</Label>
  //       <Input type="select" defaultValue={""} value={this.state[name]}
  //         onChange={e => this.onChange(e, item)}
  //         >
  //           <option value={""}></option>
  //           {selectData.slice().map((item, i) => (
  //             <option key={"option"+i} value={item.value}>{item.title}</option>
  //           ))}
  //       </Input>
  //       { this.state[name].includes("__") && 
  //       <Row>
  //         <Col xs="12" md="6">
  //           <Input type="text" onChange={e => this.setState({ [from]: $(e.target).val() })}
  //             defaultValue={""} value={this.state[from]} placeholder={"Điền giá trị đầu"} />
  //         </Col>
  //         <Col xs="12" md="6">
  //           <Input type="text" onChange={e => this.setState({ [to]: $(e.target).val() })}
  //             defaultValue={""} value={this.state[to]} placeholder={"Điền giá trị cuối"} />
  //         </Col>
  //       </Row>
  //         }
  //     </FormGroup>
  //   )
  // }

  renderDateDuration = (item, index) => {
    const { name, label, type, dateName, isRequired } = item;
    let [start, end] = dateName;
    return (
      <FormGroup key={"propDateDuration" + index}>
        <Label style={{marginRight: 15}}>{label}: {isRequired ? "*" : ""}</Label>
        <DateRangePicker
          startDate={this.state[start]}
          startDateId={start + "_start_date_id"} 
          endDate={this.state[end]}
          endDateId={end + "_end_date_id"} 
          onDatesChange={({ startDate, endDate }) => this.setState({ [start]: startDate, [end]: endDate })} 
          focusedInput={this.state["focusedInput"+start]} 
          onFocusChange={focusedInput => this.setState({ ["focusedInput"+start]: focusedInput })}
        />
      </FormGroup>
    )
  };

  renderStringUpload = (item, index) => {
    const { name, label, type, selectData, isRequired, urlType } = item;
    const imageStyle = urlType === "image cover" ? { width: "100%", height: 200, marginBottom: 20 } : { width: 300, height: 300, borderRadius: "100%", marginBottom: 20 };
    return (
      <FormGroup key={"propStringUpload" + index}>
        <Label htmlFor={"nf-" + name}>{label}: {isRequired ? "*" : ""}</Label>
        { urlType.includes("image") && 
        <div style={{
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          display: "flex"
        }}>
          <img src={this.state[name] || IMAGE} style={imageStyle} />
          <input type="file" id={"upload-"+name} name={"upload-"+name} style={{ display: "none" }} onChange={(e) => this.uploadInput(e, item)} />
          <label className="btn btn-danger" htmlFor={"upload-"+name}><i className="fa fa-camera"></i> Upload</label>
        </div> }
        { urlType === "file" && 
        <Fragment>
          <Input  type="text"  id={"nf-" + name} name={"nf-" + name}
            value={this.state[name]} 
            onChange={e => this.setState({ [name]: $(e.target).val() })}
          />
          <input type="file" id={"upload-"+name} name={"upload-"+name} style={{ display: "none" }} onChange={(e) => this.uploadInput(e, item)} />
          <Button color="danger" onClick={e => e.preventDefault()}><label className="btn btn-danger" htmlFor={"upload-"+name}><i className="fa fa-camera"></i> Upload</label></Button>
        </Fragment> }
      </FormGroup>
    )
  };

  renderArrayUpload = (item, index) => {
    const { name, label, type, selectData, isRequired, urlType } = item;
    const items = this.state[name] || [];
    return (
      <FormGroup key={"propArrayUpload" + index}>
        <Label htmlFor={"nf-" + name}>{label}: {isRequired ? "*" : ""}</Label>
        <div>
          <input type="file" id={"upload-"+name} name={"upload-"+name} style={{ display: "none" }} multiple onChange={(e) => this.uploadInput(e, item)} />
          <label className="btn btn-danger" htmlFor={"upload-"+name}><i className="fa fa-camera"></i> Upload Images</label>
        </div>
        { urlType === "image" && (
          <Carousel items={items} />
        )}
        { urlType === "file" && (
          <ListGroup>
            { items.map((el, index) => <ListGroupItem key={name+index}>{el}</ListGroupItem>) }
          </ListGroup>
        )}
      </FormGroup>
    )
  };

  uploadInput = async (e, item) => {
    const { name, label, type, selectData, isRequired, urlType } = item;
    if(type.includes("string")) {
      const file = e.target.files[0];
      const uploadedUrl = await Request.upload(file);
      this.setState({ [name]: uploadedUrl });
    } else if (type.includes("array")) {
      const files = Array.from(e.target.files);
      console.log(e.target);
      console.log(files);
      let result = [];

      const promiseArr = files.map(async (val) => {
        try {
          const uploadedUrl = await Request.upload(val);
          result.push(uploadedUrl);
        } catch(err) { console.log(err); }
      });

      await Promise.all(promiseArr);
      this.setState({ [name]: result });
    }
    
  };

  render() {
    const { onSubmit, template } = this.props;
    return (
      <Form onSubmit={this.onSubmit}>
        { 
          template.map((val, index) => {
            if(val.type === "string") return this.renderString(val, index);
            if(val.type === "number") return this.renderNumber(val, index);
            if(val.type === "string select") return this.renderStringSelect(val, index);
            if(val.type === "array select") return this.renderArraySelect(val, index);
            if(val.type === "array upload") return this.renderArrayUpload(val, index);
            if(val.type === "string upload") return this.renderStringUpload(val, index);
            if(val.type === "date duration") return this.renderDateDuration(val, index);
            if(val.type === "range number select") return this.renderRangeNumberSelect(val, index);
          })
        }
      </Form>
    )
  }

  onSubmit = (e) => {
    !!e && e.preventDefault();
    const { template } = this.props;
    const { filterEmptyObjProp  } = VarHelper;
    let { state } = this;
    // check required, parse Number
    for (let i = 0; i<template.length; i++) {
      let itemTemplate = template[i]
      let stateValue = state[itemTemplate.name];
      if(itemTemplate.isRequired === true && (stateValue === "" || stateValue === undefined)) return alert("Bạn cần diền trường: " + itemTemplate.label)
      if(itemTemplate.type == "number" && !!stateValue) {
        stateValue = +stateValue;
        if(isNaN(stateValue)) return alert("Trường "+ itemTemplate.label+ " phải là số" )
      }
    }
    for (let label in state) {
      if (label.includes("__") && state[label.replace("__", "")].includes("__")) {
        state[label.replace("__", "")] = state[label];
        delete state[label];
      }
    }
    console.log(state);
    typeof this.props.onSubmit === "function" && this.props.onSubmit(filterEmptyObjProp(state));
  };

  getValue = () => {
    const { template } = this.props;
    const { filterEmptyObjProp  } = VarHelper;
    let { state } = this;
    // check required, parse Number
    for (let i = 0; i<template.length; i++) {
      let itemTemplate = template[i]
      let stateValue = state[itemTemplate.name];
      if(itemTemplate.isRequired === true && (stateValue === "" || stateValue === undefined)) return alert("Bạn cần diền trường: " + itemTemplate.label)
      if(itemTemplate.type == "number" && !!stateValue) {
        stateValue = +stateValue;
        if(isNaN(stateValue)) return alert("Trường "+ itemTemplate.label+ " phải là số" )
      }
    }
    for (let label in state) {
      if (label.includes("__") && state[label.replace("__", "")].includes("__")) {
        state[label.replace("__", "")] = state[label];
        delete state[label];
      }
    }
    return filterEmptyObjProp(state);
  };
}



// WEBPACK FOOTER //
// ./src/custom/MakeForm.js